import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useDarkMode() {
  const [isDark, setIsDark] = useState(false);

  // Load dark mode preference from localStorage first
  useEffect(() => {
    const darkMode = localStorage.getItem('darkMode') === 'true';
    setIsDark(darkMode);
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  useEffect(() => {
    const loadUserPreference = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) return;

        const { data: profile } = await supabase
          .from('profiles')
          .select('dark_mode')
          .eq('user_id', session.user.id)
          .single();

        if (profile?.dark_mode !== undefined) {
          setIsDark(profile.dark_mode);
          localStorage.setItem('darkMode', profile.dark_mode.toString());
          if (profile.dark_mode) {
            document.documentElement.classList.add('dark');
          } else {
            document.documentElement.classList.remove('dark');
          }
        }
      } catch (error) {
        console.error('Error loading dark mode preference:', error);
      }
    };

    loadUserPreference();
  }, []);

  const setDarkMode = async (value: boolean) => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) return;

      const { error } = await supabase
        .from('profiles')
        .update({ dark_mode: value })
        .eq('user_id', session.user.id);

      if (error) throw error;

      setIsDark(value);
      localStorage.setItem('darkMode', value.toString());
      if (value) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    } catch (error) {
      console.error('Error updating dark mode preference:', error);
    }
  };

  return [isDark, setDarkMode] as const;
}